// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 微信小程序登录 POST /wx/ma/login */
export async function wxMaLoginUsingPOST(body: API.WxMaLoginReq, options?: { [key: string]: any }) {
  return request<API.BaseResultWxMaLoginResp>('/wx/ma/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 小程序默认手机号注册 POST /wx/ma/register */
export async function wxMaRegisterUsingPOST(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.wxMaRegisterUsingPOSTParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultWxMaLoginResp>('/wx/ma/register', {
    method: 'POST',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
